<script setup lang="ts">
import type { IProps } from './career-ctaBoxes.types'

const { isTablet } = useBSBreakpoints()

const setBackground = (desktopImage: Record<string, string>, mobileImage: Record<string, string>) => {
  return {
    backgroundImage: `url(${isTablet.value ? desktopImage.src || desktopImage.url : mobileImage.src || mobileImage.url})`,
  }
}

defineProps<IProps>()
</script>

<template>
  <clientOnly>
    <div
      class="ui-cta-boxes"
      :class="ctaBoxes.length > 1 && 'ui-cta-boxes--multiply'"
    >
      <div
        v-for="(ctaBox, index) in ctaBoxes"
        :key="index"
        :style="setBackground(ctaBox.desktopBackgroundImage, ctaBox.mobileBackgroundImage)"
        class="ui-cta-box"
      >
        <div>
          <img
            v-if="ctaBox.leadImage"
            class="ui-cta-box__image"
            :src="ctaBox.leadImage.url"
            alt=""
            title=""
          >
        </div>

        <div class="ui-cta-box__wrapper">
          <h1
            class="ui-cta-box__title"
            :class="!ctaBox.lead && 'ui-cta-box__title--bigSpace'"
          >
            {{ ctaBox.title }}
          </h1>

          <p
            v-if="ctaBox.lead"
            class="ui-cta-box__lead"
          >
            {{ ctaBox.lead }}
          </p>

          <UiButton v-bind="{...ctaBox.button}">
            {{ ctaBox.button?.label }}
          </UiButton>
        </div>
      </div>
    </div>
  </clientOnly>
</template>

<style lang="scss" scoped>
.ui-cta-boxes {
  $self: &;
  display: flex;
  margin: auto;

  &--multiply {
    flex-direction: column;
    gap: 2.4rem;
    width: 100%;
    margin: 0;

    .ui-cta-box {
      max-width: inherit !important;
      width: 100%;
    }
  }

  .ui-cta-box {
    padding: 3.2rem;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 1.2rem;

    &__title {
      @include h9;
      padding-top: 1.6rem;
      padding-bottom: 1.6rem;
      color: $darkblue-400;
    }

    &__lead {
      @include body-1-medium;
      padding-bottom: 2.4rem;
      color: $darkblue-400;
    }

    &__wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    img {
      max-inline-size: none;
    }
  }

  @include atS {
    flex-direction: row;
    justify-content: center;

    .ui-cta-box {
      display: flex;
      gap: 4.8rem;
      max-width: 87.3rem;

      &__title {
        width: 70%;

        &--bigSpace {
          padding-bottom: 6.4rem;
        }
      }

      &__lead {
        width: 70%;
      }
    }
  }

  @include atM {
    max-width: 136rem;
    margin: auto;
  }
}
</style>
